<div style="width: 95%;" [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
    <div mat-dialog-title class="modal-header-bg d-flex justify-content-end px-3 pt-1"></div>
    <div mat-dialog-content>
      <h4 class="font-weight-bold title-text">
        {{ "coupons-modal-title" | translate }}
        <img src="assets/img/Complaint.svg" alt="Complaint" class="withdraw-icon">
      </h4>
      <p class="text-muted-special subtitle-text">{{ "coupons-modal-subtitle" | translate }}</p>
  
      <div class="settings-profile">
        <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
          <div class="overlay-content">
            {{ "choose-account" | translate }}
          </div>
        </div> -->
        <form #complaintForm="ngForm" (ngSubmit)="submitCoupon(complaintForm)">
          <div class="form-row">
            <div class="col-md-6 mb-3">
                <label class="required form-field-title">{{ "accounts" | translate }}</label>
                    <ng-select
                      [formControl]="selectedAccountControl"
                      (ngModelChange)="onAccountChange($event)"
                      [searchable]="false"
                      class="custom"
                      name="RelationCode"
                      [dropdownPosition]="'bottom'"
                      required
                      [placeholder]="'accounts' | translate">
                        <ng-template ng-label-tmp let-item="selectedAccount">
                        <span *ngIf="translate.currentLang === 'en'">
                          {{ selectedAccount.clientNameEn }} — {{ (selectedAccount.accountTypeEn )}}
                        </span>

                        <span *ngIf="translate.currentLang === 'ar'" class="option-ar">
                          <span>{{ selectedAccount.clientNameAr }}</span> -
                          <span>({{ selectedAccount.accountTypeAr }})</span>
                        </span>
                      </ng-template>

                      <ng-option *ngFor="let Acc of userAccounts" [value]="Acc.relationCode">
                        <span *ngIf="translate.currentLang === 'en'">
                          {{ Acc.clientNameEn }} — {{ Acc.accountTypeEn }}
                        </span>

                        <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                          <span>{{ Acc.clientNameAr }}</span>
                          <span>{{ Acc.accountTypeAr }}</span>
                        </span>
                      </ng-option>
                    </ng-select>
              </div>
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{ "stocks" | translate }}</label>
              <ng-select [searchable]="false" class="custom" #SymbolCodes="ngModel" ngModel name="SymbolCodes" [dropdownPosition]="'bottom'" required [placeholder]="'stocks' | translate">
                <ng-option *ngFor="let stock of clientStocks" [value]="stock.SymbolCode">
                  {{ translate.currentLang == "en" ? stock.SymbolNameEn : stock.SymbolNameAr }}
                </ng-option>
              </ng-select>
            </div>


          </div>
          <div class="col-12 d-flex justify-content-end" style="justify-content: end">
            <button class="btn btn-primary" type="submit" [disabled]="complaintForm.invalid || isSubmitting || !selectedAccount">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
              {{ "Submit" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>